import React from 'react';
import { DUKE_SKIN_IMAGES } from '../config/DukeSkins';
import { PIECE_SKIN_IMAGES, getSkinCategory } from '../config/PieceSkins';

// Duke skins that support color customization (purchasable skins only)
const COLORIZABLE_DUKE_SKINS = ['spartanShield', 'crownShield', 'flameWarrior', 'flameCrown', 'flameWarriorV2', 'flameCrownV2'];

const Piece = ({ type, side, embodiment, dukeSkin, pieceSkin }) => {
  // For Duke pieces, use custom shield images based on embodiment mode and skin
  if (type === 'duke') {
    const skin = dukeSkin || 'default';
    const skinImages = DUKE_SKIN_IMAGES[skin] || DUKE_SKIN_IMAGES.default;
    const isColorizable = COLORIZABLE_DUKE_SKINS.includes(skin);
    
    let dukeImage;
    let embodimentClass = '';
    // Pro modes (fight_to_be_king_pro_1 / pro_2) are variants of Fight to be King — use same Duke art.
    const isFightToBeKing = typeof embodiment === 'string' && embodiment.startsWith('fight_to_be_king');
    if (isFightToBeKing) {
      dukeImage = skinImages.fight_to_be_king;
      embodimentClass = 'fight-to-be-king';
    } else {
      dukeImage = skinImages.instant_king;
      embodimentClass = 'instant-king';
    }
    
    // For colorizable Duke skins, use simplified tinting approach
    if (isColorizable) {
      return (
        <div className={`duke-wrapper ${side} duke-skin-${skin} ${embodimentClass} colorizable`}>
          <img 
            src={dukeImage} 
            alt={`${side} duke`} 
            className={`chess-piece-img duke colorizable-duke ${side}`}
            draggable="false"
          />
        </div>
      );
    }
    
    return (
      <div className={`duke-wrapper ${side} duke-skin-${skin} ${embodimentClass}`}>
        <img 
          src={dukeImage} 
          alt={`${side} duke`} 
          className={`chess-piece-img duke ${side}`}
          draggable="false"
        />
      </div>
    );
  }

  // Check if piece skin is selected and has an image for this piece type
  if (pieceSkin && PIECE_SKIN_IMAGES[pieceSkin]) {
    const pieceImage = PIECE_SKIN_IMAGES[pieceSkin][type];
    
    // If piece image exists, render it
    if (pieceImage) {
      const skinCategory = getSkinCategory(pieceSkin);
      const skinClass = `${skinCategory}-skin`;
      
      return (
        <div className={`piece-skin-wrapper ${side} skin-${pieceSkin}`}>
          <img 
            src={pieceImage} 
            alt={`${side} ${type}`} 
            className={`chess-piece-img skinned-piece ${skinClass} ${side}`}
            draggable="false"
          />
        </div>
      );
    }
  }

  // Fallback to Unicode pieces if no skin image
  const pieces = {
    white: { king: '♔', queen: '♕', rook: '♖', bishop: '♗', knight: '♘', pawn: '♙', duke: '⛊' },
    black: { king: '♚', queen: '♛', rook: '♜', bishop: '♝', knight: '♞', pawn: '♟', duke: '⛉' }
  };

  return <span className={`chess-piece ${side}`}>{pieces[side][type]}</span>;
};

export default Piece;
